module.exports = __webpack_public_path__ + "img/mn6.42cfb43d.jpg";